import React from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import LoaderComponent from '../components/Loader';

const OVERLAY_ID = 'session-guard-overlay';

let overlayRoot = null;

export const showSigningOut = () => {
    if (document.getElementById(OVERLAY_ID)) return;
    const overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-label', 'Signing out');
    Object.assign(overlay.style, {
        position: 'fixed',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        zIndex: '1000',
        overflow: 'hidden',
        background: '#ffffff',
    });
    document.body.appendChild(overlay);
    overlayRoot = createRoot(overlay);
    flushSync(() => {
        overlayRoot.render(React.createElement(LoaderComponent));
    });
};

export const hideSigningOut = () => {
    if (overlayRoot) {
        overlayRoot.unmount();
        overlayRoot = null;
    }
    const overlay = document.getElementById(OVERLAY_ID);
    if (overlay) overlay.remove();
};
